<template>
      <v-container
        class="fill-height container-img"
      >
        <v-img class="img-vertical" cover max-height="100%" src="@/assets/imagenes_home/home_01_vertical.jpg"></v-img>
        <v-img class="img-hori" cover src="@/assets/imagenes_home/home_01.jpg"></v-img>
      </v-container>
</template>



<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "home",

  data() {
    return {
      mensaje: { tipo: "S", mensaje: "hi", tiempo: null }, // mensaje de sistema

      datoLogin: sessionStorage, // sesion del sistema
      paramComponente: { id_modulo: 4, id_submodulo: 2 },
      prueba: null,
    };
  },

  mounted() {
    //console.log("saludar")
  },

  created() {
    this.setTituloMenu("INICIO");
    this.actualizarParamentro();
    //this.prueba = "hola wuilmer"
    this.prueba = this.$i18n.t("titulo.salon");
  },

  methods: {
    ...mapMutations(["setTituloMenu"]),
    ...mapActions("login", ["parametroComponente"]),
    ...mapMutations("mensajeSis", ["setEnviar"]),
    
    enviarMensaje() {
      //this.setEnviar(this.mensaje);
    },

    actualizarParamentro() {
      //  alert(JSON.stringify(process.env));
      //console.log( `parametroComponente ${JSON.stringify(this.paramComponente)}`)
      //alert(this.URL_FRONDEND)
      this.enviarMensaje()
      this.parametroComponente(this.paramComponente);
    },
    
  },

  computed: {
    // a computed getter
    ...mapGetters("login", ["componenteEvento"]),
  },
};
</script>



<style scoped>



  .img-vertical{
      display: none;
  }

  @media (max-width: 830px) {
  /* … */
    .img-vertical{
      display: block;
    }
    .img-hori{
      display: none;
    }
  }


</style>